/* import __COLOCATED_TEMPLATE__ from './activity-list.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
let ActivityListComponent = (_class = class ActivityListComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  pendingHeader() {
    return {
      isHeader: true,
      id: 'pending-header',
      title: this.intl.t('banking.shared.activity.pending')
    };
  }
  dateRow(date) {
    return {
      isHeader: true,
      id: date.toISOString(),
      title: this.intl.formatDate(date, {
        month: 'short',
        year: 'numeric',
        day: 'numeric'
      })
    };
  }
  // The ActivityList needs to be flattened to prevent a class of scroll
  // bugs that occur because the nested groups of activities triggers brief
  // glitches in which the Completed section of activities has a height of 0
  // So we flatten the list so that there's no nested groups
  // We also add `id`s to the headers so that we correctly use the `key` property
  // on the #each block in the template
  get flattenedActivityList() {
    const flattenedActivityList = [];

    // First push the pending header and pending activities to the list
    if (this.args.activityList.pending.length > 0) {
      flattenedActivityList.push(this.pendingHeader(), ...this.args.activityList.pending);
    }

    // Next, flatten the completed list of activities and add date headers into it
    this.args.activityList.completed.forEach(month => {
      flattenedActivityList.push(this.dateRow(month.date));
      month.activities.forEach(activity => {
        flattenedActivityList.push(activity);
      });
    });
    return flattenedActivityList;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ActivityListComponent as default };